
import { defineComponent } from "vue";
export default defineComponent({
  name: "familia-prioritaria-modal",
  components: {},
});
